module.exports = __webpack_public_path__ + "img/playbutton1.2be7e628.png";